import React from 'react'
import 'keen-slider/keen-slider.min.css'
import { useKeenSlider } from 'keen-slider/react'
import {
  Container,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Box,
  IconButton,
} from '@mui/material'
import { ChevronLeft, ChevronRight } from '@mui/icons-material'
import SecondaryButton from './Assets/SecondaryButton'

const testimonials = [
  {
    id: 1,
    text: 'The dashboard is incredibly intuitive and easy to navigate – a true standout feature!',
    imageUrl: '/assets/images/avatars/male/avatar_9.jpg',
  },
  {
    id: 2,
    text: 'Real-time alerts have been a lifesaver, helping us avoid potential downtime and service interruptions.',
    imageUrl: '/assets/images/avatars/female/avatar_5.jpg',
  },
  {
    id: 3,
    text: 'A highly scalable solution that grows with our business – perfect for expanding teams and infrastructure.',
    imageUrl: '/assets/images/avatars/male/avatar_5.jpg',
  },
  {
    id: 4,
    text: 'Top-tier security features that ensure peace of mind and protect our critical systems.',
    imageUrl: '/assets/images/avatars/female/avatar_6.jpg',
  },
  {
    id: 5,
    text: 'The detailed metrics provide actionable insights that drive better decision-making across teams.',
    imageUrl: '/assets/images/avatars/female/avatar_6.jpg',
  },
]

const Testimonial = () => {
  const [currentSlide, setCurrentSlide] = React.useState(0)

  function AutoplayPlugin(slider) {
    let timeout
    let mouseOver = false

    function clearNextTimeout() {
      clearTimeout(timeout)
    }

    function nextTimeout() {
      clearTimeout(timeout)
      if (mouseOver) return
      timeout = setTimeout(() => {
        slider.next()
      }, 3000)
    }

    slider.on('created', () => {
      slider.container.addEventListener('mouseover', () => {
        mouseOver = true
        clearNextTimeout()
      })
      slider.container.addEventListener('mouseout', () => {
        mouseOver = false
        nextTimeout()
      })
      nextTimeout()
    })
    slider.on('dragStarted', clearNextTimeout)
    slider.on('animationEnded', nextTimeout)
    slider.on('updated', nextTimeout)
  }

  const [sliderRef, instanceRef] = useKeenSlider(
    {
      loop: true,
      mode: "snap",
      slides: {
        origin: 'center',
        perView: 1,
        spacing: 20,
      },
      breakpoints: {
        '(min-width: 768px)': {
          slides: { perView: 2, spacing: 24 },
        },
        '(min-width: 1024px)': {
          slides: { perView: 3, spacing: 28 },
        },
      },
      animation: {
        duration: 500,
        easing: t => {
          const newT = t - 1
          return newT * newT * newT + 1
        },
      },
      slideChanged(slider) {
        setCurrentSlide(slider.track.details.rel)
      },
    },
    [AutoplayPlugin]
  )


  return (
    <Box sx={{ background: 'linear-gradient(to right, #f9fafb, #fff)', pt: "2.5%", pb: "4.5%" }}>
      <Container id="testimonial" maxWidth="lg">
        <Box sx={{ textAlign: 'center', marginBottom: '60px' }}>
          <h2
            style={{
              color: '#002244',
              fontSize: '2.8rem',
              fontWeight: '700',
              textAlign: 'center',
            }}
          >
            What Our Customers Say
          </h2>
          <Typography component="p" variant="h4" sx={{ color: '#4b5563' }}>
            Trusted by professionals worldwide
          </Typography>
        </Box>

        <div ref={sliderRef} className="keen-slider testimonial-carousel">
          {testimonials.map((testimonial) => (
            <div key={testimonial.id} className="keen-slider__slide testimonial-item">
              <Card className="testimonial-card">
                <CardMedia
                  component="img"
                  alt=""
                  src={testimonial.imageUrl}
                  className="testimonial-image"
                />
                <CardContent >
                  {/* <Typography className="testimonial-name">
                    {testimonial.name}
                  </Typography> */}
                  <Typography style={{
                    color: '#003366',
                    fontSize: '1rem',
                    lineHeight: '1.6',
                  }}>
                    {testimonial.text}
                  </Typography>
                </CardContent>
              </Card>
            </div>
          ))}
        </div>

        {/* Navigation Buttons */}
        <Box className="slider-arrows">
          <IconButton
            className="arrow left"
            onClick={() => instanceRef.current?.prev()}
            aria-label="Previous testimonial"
          >
            <ChevronLeft color='primary' />
          </IconButton>
          <IconButton
            className="arrow right"
            onClick={() => instanceRef.current?.next()}
            aria-label="Next testimonial"
          >
            <ChevronRight color='primary' />
          </IconButton>
        </Box>


        {/* Dots */}
        <Box className="dot-container">
          {testimonials.map((_, idx) => (
            <button
              type='button'
              key={idx}
              onClick={() => instanceRef.current?.moveToIdx(idx)}
              className={`dot-bar ${currentSlide === idx ? 'active' : ''}`}
              aria-label={`Go to testimonial ${idx + 1}`}
            />

          ))}
        </Box>

        <Box sx={{ display: 'flex', justifyContent: 'center', mt: 4 }}>
          <SecondaryButton text="See All Testimonials" to="/testimonial" />
        </Box>

        {/* Inline Styles */}
        <style>{`
          .testimonial-carousel {
            margin-bottom: 2rem;
          }

          .keen-slider__slide {
            display: flex;
            justify-content: center;
            transition: all 0.4s ease;
          }

          .testimonial-card {
          height: 300px;
            padding: 30px;
            text-align: center;
            border:1px solid #0056b3;
            border-radius: 15px;
            box-shadow: 0 8px 20px rgba(0, 64, 128, 0.15);
            background: white;
            transition: transform 0.3s ease, box-shadow 0.3s ease;
          }

          .testimonial-card:hover {
            transform: translateY(-5px);
          }

          .testimonial-image {
            border-radius: 50%;
            width: 80px;
            height: 80px;
            margin: 0 auto 1rem;
            object-fit: cover;
          }

          .testimonial-name {
            font-weight: 600;
            font-size: 16px;
            margin-bottom: 0.5rem;
          }

          .testimonial-text {
            color: #555;
            font-size: 14px;
            line-height: 1.6;
          }

          .slider-arrows {
  position: relative;
  margin-top: 1rem;
}
.slider-arrows .arrow {
  position: absolute;
  top: 40%;
  transform: translateY(-50%);
  background: white;
  border: 1px solid #ddd;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
  z-index: 2;
  transition: background 0.3s ease;
}
.slider-arrows .arrow:hover {
  background: #f0f0f0;
}
.slider-arrows .arrow.left {
  left: -24px;
}
.slider-arrows .arrow.right {
  right: -24px;
}

.dot-container {
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  gap: 6px;
}

.dot-bar {
  width: 30px;
  height: 6px;
  background-color: #ddd;
  border-radius: 3px;
  cursor: pointer;
  transition: all 0.3s ease;
  border: 1px hidden black;
}
.dot-bar.active {
  background-color:#2065D1;
  width: 38px;
}

        `}</style>
      </Container>
    </Box>
  )
}

export default Testimonial
